import style from './map.module.scss';
import React, {useRef, useState} from "react";
import {OverlayView} from "@react-google-maps/api";
import {clearMap, searchMap} from "../../util/assets";
import {
    findingNearPointMap,
    setActiveMapData,
    setCurrentItem,
    setCurrentItemLoaderLogs,
    setGeoMap,
    sortByCentreSearchMap
} from "../../action/page";
import {getLogs} from "../../thunk/device";
import {getAddressMap} from "../../thunk/map";
import {connect} from "react-redux";
import {setCurrentAlert} from "../../action/alert";

function InfoWindowMap({
                           page,
                           sortByCentreSearchMap,
                           setCurrentItem,
                           getLogs,
                           getAddressMap,
                           setCurrentAlert,
                           findingNearPointMap
                       }) {
    // const handlerChangeStatus = (id, coord, active) => {
    //     sortByCentreSearchMap({centre: coord});
    //     setCurrentItem({id: id, active, status: "clickByTarget"});
    //     // findingNearPointMap();
    // }
    const handlerChangeStatus = (index) => {
        setActiveMapData({index});
        setCurrentItem(page.data[index].active?page.data[index]:{});
        getLogs({id: page.data[index]._id});
        setCurrentAlert({id: page.data[index]._id});
        getAddressMap(page.data[index].location.join(", "));
    }
    return (
        <>
            {page.data && page.data.map(
                ({location, aqiValue, aqi, active, _id, showOnMap}, index) => showOnMap && location?.length && (
                    <OverlayView key={`${index}_location`}
                                 position={{lat: location[0], lng: location[1]}}
                                 options={{closeBoxURL: ``, enableEventPropagation: true}}
                                 zIndex={active ? 15 : ""}
                                 mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}


                    >
                        <div
                            onClick={() => {
                                // handlerChangeStatus(index, _id, location, active)
                                handlerChangeStatus(index)
                            }}
                            className={[style.markerRow, style[`status${!isNaN(aqi) ? aqi : 'Nan'}`], active ? style.active : "", style[page.map.typeIcon]].join(" ")}
                        >
                            <div className={style.markerItem}>
                                {aqiValue && page.map.typeIcon !== "small" ? aqiValue > 500 ? "500+" : aqiValue : ""}
                            </div>
                        </div>
                    </OverlayView>
                )
            ) || ""}
        </>
    )
}

const mapStateToProps = state => ({
    page: state.page,
});

const mapDispatchToProps = dispatch => ({
    // login: data => dispatch(login(data))
    setActiveMapData: data => dispatch(setActiveMapData(data)),
    setCurrentItem: data => dispatch(setCurrentItem(data)),
    getLogs: data => dispatch(getLogs(data)),
    getAddressMap: data => dispatch(getAddressMap(data)),
    setCurrentAlert: data => dispatch(setCurrentAlert(data)),
    findingNearPointMap: data => dispatch(findingNearPointMap(data)),
    sortByCentreSearchMap: data => dispatch(sortByCentreSearchMap(data)),
    setCurrentItemLogs: data => dispatch(setCurrentItemLoaderLogs(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InfoWindowMap);